export default __webpack_public_path__ + "static/media/Book8.82145526.pdf";